"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableColumnChart_1 = require("./PluggableColumnChart");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var sdk_model_1 = require("@gooddata/sdk-model");
var drillDownUtil_1 = require("../drillDownUtil");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var util_1 = require("@gooddata/util");
var ImplicitDrillDownHelper_1 = require("../../../utils/ImplicitDrillDownHelper");
var ColumnChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnChartDescriptor, _super);
    function ColumnChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableColumnChart_1.PluggableColumnChart(params); };
    };
    ColumnChartDescriptor.prototype.applyDrillDown = function (insight, drillDownContext) {
        var withFilters = this.addFiltersForColumnBar(insight, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    ColumnChartDescriptor.prototype.adjustIntersectionForColumnBar = function (insight, event) {
        var stackBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.STACK);
        var hasStackByAttributes = stackBucket && !sdk_model_1.bucketIsEmpty(stackBucket);
        var intersection = event.drillContext.intersection;
        return hasStackByAttributes ? util_1.arrayUtils.shiftArrayRight(intersection) : intersection;
    };
    ColumnChartDescriptor.prototype.addFiltersForColumnBar = function (insight, drillConfig, event) {
        var clicked = ImplicitDrillDownHelper_1.drillDownFromAttributeLocalId(drillConfig);
        var reorderedIntersection = this.adjustIntersectionForColumnBar(insight, event);
        var cutIntersection = sdk_ui_1.getIntersectionPartAfter(reorderedIntersection, clicked);
        return drillDownUtil_1.addIntersectionFiltersToInsight(insight, cutIntersection);
    };
    return ColumnChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.ColumnChartDescriptor = ColumnChartDescriptor;
//# sourceMappingURL=ColumnChartDescriptor.js.map